import React, { useRef, useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// component
import ScrollToTop from 'component/ScrollToTop'
// import PageTop from 'page/top/PageTop'
import PageIndex from 'page/index/PageIndex'
import PageActivity from 'page/activity/PageActivity'
import PageFloor from 'page/floor/PageFloor'
import PageNew from 'page/new/PageNew'
import PageFloorMap from 'page/floormap/PageFloorMap'
import PageAbout from 'page/about/PageAbout'
import PageAccess from 'page/access/PageAccess'

export default function AppRoute() {

  const router = useRef(null);

  let testPath:string = '';

  // 環境によるパスのだし分け
  if(window.location.host === 'localhost:3000'){  // ローカルサーバー
    console.log('ローカルサーバー');
    testPath = '';
  }else{
    testPath = '/digital/fair2021/showroom';
    // if(window.location.pathname.indexOf('/lprl/') !== -1){  // テストサーバー
    //   console.log('テストサーバー');
    //   testPath = '/digital/fair2021/showroom';
    // }else{  // 本番サーバー
    //   console.log('本番サーバー');
    //   testPath = '/showroom';
    // }
  }


  useEffect(() => {
    // if(router !== null && 'current' in router){
    //   router.current.history.listen((location:any) => {
    //     (window as any).gtag('config', 'トラッキングID', {
    //       'page_path': `${location.pathname}${location.search}`
    //     });
    //   });
    // }
  });

  return (
    <React.StrictMode>
      <Provider store={store}>
        <Router ref={router}>
          <ScrollToTop />
          <Switch>
            {/* <Route path="/digital/fair2021/showroom/all.html" exact render={props => <PageIndex testPath={testPath} {...props} />}></Route> */}
            <Route path="/digital/fair2021/showroom/activity.html" exact render={props => <PageActivity testPath={testPath} {...props} />}></Route>
            <Route path="/digital/fair2021/showroom/floor:floor/area:area.html" exact render={props => <PageFloor testPath={testPath} {...props} />}></Route>
            <Route path="/digital/fair2021/showroom/new.html" exact render={props => <PageNew testPath={testPath} {...props} />}></Route>
            <Route path="/digital/fair2021/showroom/floormap.html" exact render={props => <PageFloorMap testPath={testPath} {...props} />}></Route>
            <Route path="/digital/fair2021/showroom/about.html" exact render={props => <PageAbout testPath={testPath} {...props} />}></Route>
            <Route path="/digital/fair2021/showroom/access.html" exact render={props => <PageAccess testPath={testPath} {...props} />}></Route>
            <Route render={props => <PageIndex testPath={testPath} {...props} />}></Route>
          </Switch>
        </Router>
      </Provider>
    </React.StrictMode>
  );
}
